export default __webpack_public_path__ + "static/media/2.846f841a.jpg";